import { apolloClient as defaultApolloClient } from "@/config/apollo";
import { FormAnswerDataFetcher } from "./FormAnswerDataFetcher";
import { FormAnswerDataMerger } from "./FormAnswerDataMerger";

class DynamicFormService {
  constructor(options = {}) {
    this.apolloClient = options.apolloClient || defaultApolloClient;
  }

  async fetchAndMergeAnswerData({ dynamicForm, answerableId, answerableType }) {
    const answerDataValues = await new FormAnswerDataFetcher({
      apolloClient: this.apolloClient,
    }).fetchAnswerDataForDynamicForm({
      dynamicForm,
      answerableId,
      answerableType,
    });

    return new FormAnswerDataMerger().mergeDynamicFormWithResults(
      dynamicForm,
      answerDataValues
    );
  }
}

export { DynamicFormService };
